$(document).ready(function () {
  $('.column-with-icon').matchHeight();

  $('button.js-toggle-submenu').click(function () {
    $(this).siblings('.mobile-nav__dropdown').slideToggle()
    $(this).addClass('sub-nav-is-open');
    $('.mobile-nav__dropdown').not($(this).siblings('.mobile-nav__dropdown')).slideUp();
    $('button.js-toggle-submenu').not(this).removeClass('sub-nav-is-open');
  });

});




// When the user scrolls down 20px from the top of the document, show the button
window.onscroll = function() {scrollFunction()};

function scrollFunction() {
  if (document.body.scrollTop > 260 || document.documentElement.scrollTop > 260) {
    document.getElementById("back-to-top").style.display = "block";
  } else {
    document.getElementById("back-to-top").style.display = "none";
  }
}

// When the user clicks on the button, scroll to the top of the document
function topFunction() {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
}



// prevents widows/orphans 
// $(function($) {
//     $('p').each(function() {
//         $(this).html($(this).html().replace(/\s([^\s<]+)\s*$/,'&nbsp;$1'));
//     });
// });


jQuery('<div class="quantity-nav-left"><div class="quantity-button quantity-down">-</div></div>').insertBefore('.qty-wrapper input'); 
jQuery('<div class="quantity-nav-right"><div class="quantity-button quantity-up">+</div></div>').insertAfter('.qty-wrapper input');

jQuery('.qty-wrapper').each(function() {
  var spinner = jQuery(this),
    input = spinner.find('input[type="number"]'),
    btnUp = spinner.find('.quantity-up'),
    btnDown = spinner.find('.quantity-down'),
    min = input.attr('min'),
    max = input.attr('max');

  btnUp.click(function() {
    var oldValue = parseFloat(input.val());
    if (oldValue >= max) {
      var newVal = oldValue;
    } else {
      var newVal = oldValue + 1;
    }
    spinner.find("input").val(newVal);
    spinner.find("input").trigger("change");
  });

  btnDown.click(function() {
    var oldValue = parseFloat(input.val());
    if (oldValue <= min) {
      var newVal = oldValue;
    } else {
      var newVal = oldValue - 1;
    }
    spinner.find("input").val(newVal);
    spinner.find("input").trigger("change");
  });

});

// cart quantity control

jQuery('.cart__update-wrapper').each(function() {
  var spinner = jQuery(this),
    input = spinner.find('input[type="number"]'),
    btnUp = spinner.find('.quantity-up'),
    btnDown = spinner.find('.quantity-down'),
    min = input.attr('min'),
    max = input.attr('max');

  btnUp.click(function() {
    var oldValue = parseFloat(input.val());
    if (oldValue >= max) {
      var newVal = oldValue;
    } else {
      var newVal = oldValue + 1;
    }
    spinner.find("input").val(newVal);
    spinner.find("input").trigger("change");
  });

  btnDown.click(function() {
    var oldValue = parseFloat(input.val());
    if (oldValue <= min) {
      var newVal = oldValue;
    } else {
      var newVal = oldValue - 1;
    }
    spinner.find("input").val(newVal);
    spinner.find("input").trigger("change");
  });

});